import { useCallback } from "react";
import { toast } from "react-toastify";

export const useLandlordDetailMetrics = (
  filters,
  getWorkspaceMetricsFullInfo,
  setLandlordMetricsList,
  setLoadingDetails
) => {
  const fetchLandlordDetailMetrics = useCallback(async (landlordId, workspaceId) => {
    setLoadingDetails(true);
    try {
      const response = await getWorkspaceMetricsFullInfo(
        {
          startDate : filters.startDate,
          endDate : filters.endDate,
          landlordId : landlordId,
          workspaceId : workspaceId,
          tenantId : "",
          self_serving : filters.selfServing,
          landlord_type: filters.landlordType,
          signal : null
        }
      );

      if (response && response.success && response.data) {
        setLandlordMetricsList(response.data);
      } else {
        setLandlordMetricsList([]);
      }
    } catch (err) {
      console.error("Error fetching landlord detail metrics:", err);
      toast.error("Failed to fetch landlord details");
      setLandlordMetricsList([]);
    } finally {
      setLoadingDetails(false);
    }
  }, [filters.startDate, filters.endDate, filters.selfServing, filters.landlordType, getWorkspaceMetricsFullInfo, setLandlordMetricsList, setLoadingDetails]);

  return {
    fetchLandlordDetailMetrics,
  };
};